import { createContext } from "react";

import type { BookingVisualVariantTokens } from "./bookingVisualVariants";

/**
 * The active skin's resolved tokens, or `null` on a flat preset and outside
 * a booking root. For surfaces no CSS variable reaches — Stripe's card field
 * is an iframe — so they can follow a skin while flat presets keep their
 * own defaults.
 */
export const BookingSkinTokensContext =
  createContext<BookingVisualVariantTokens | null>(null);
